import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideEntrepriseStub } from '../../../../config/aides-entreprises';

export default function CeeBatPage() {
  const aide = getAideEntrepriseStub('cee-bat');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="entreprises" />;
}
